import { Link } from "office-ui-fabric-react";

const ProjectStatusCalculationSettingsTooltip = () => {
    return <span>Define the settings for automatic calculation or manual definition of project statuses. Please refer to the <Link href="https://help.ppm.express/94162-portfolio-and-project-management/563277" target="_blank">article</Link> for more details.</span>;
}

export default ProjectStatusCalculationSettingsTooltip;